export default __webpack_public_path__ + "static/media/PV-MH-HAT-BACK.1da50752.png";